import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  insuredRisksForSelectedPolicy: [],
  insuredRisksForSelectedPolicyStatus: IDLE,

  insuredRisksFromManyPolicies: [],
  insuredRisksFromManyPoliciesStatus: IDLE,

  addInsuredRisksToPolicyStatus: IDLE,
  updateInsuredRisksToPolicyStatus: IDLE,

  bulkAssignInsuredRisksStatus: IDLE,
  bulkUnassignInsuredRisksStatus: IDLE
};

const insuredRisksToPoliciesSlice = createSlice({
  name: 'insuredRisksToPolicies',
  initialState,
  reducers: {
    getInsuredRisksForSelectedPolicy: (state) => {
      state.insuredRisksForSelectedPolicyStatus = LOADING;
    },
    getInsuredRisksForSelectedPolicySucceeded: (state, action) => {
      state.insuredRisksForSelectedPolicyStatus = SUCCEEDED;
      state.insuredRisksForSelectedPolicy = action.payload;
    },
    getInsuredRisksForSelectedPolicyFailed: (state) => {
      state.insuredRisksForSelectedPolicyStatus = FAILED;
    },

    getInsuredRisksFromManyPolicies: (state) => {
      state.insuredRisksFromManyPoliciesStatus = LOADING;
    },
    getInsuredRisksFromManyPoliciesSucceeded: (state, action) => {
      state.insuredRisksFromManyPoliciesStatus = SUCCEEDED;
      state.insuredRisksFromManyPolicies = action.payload;
    },
    getInsuredRisksFromManyPoliciesFailed: (state) => {
      state.insuredRisksFromManyPoliciesStatus = FAILED;
    },

    bulkAssignInsuredRisks(state) {
      state.bulkAssignInsuredRisksStatus = LOADING;
    },
    bulkAssignInsuredRisksSucceeded(state) {
      state.bulkAssignInsuredRisksStatus = SUCCEEDED;
    },
    bulkAssignInsuredRisksFailed(state) {
      state.bulkAssignInsuredRisksStatus = FAILED;
    },

    bulkUnassignInsuredRisks(state) {
      state.bulkUnassignInsuredRisksStatus = LOADING;
    },
    bulkUnassignInsuredRisksSucceeded(state) {
      state.bulkUnassignInsuredRisksStatus = SUCCEEDED;
    },
    bulkUnassignInsuredRisksFailed(state) {
      state.bulkUnassignInsuredRisksStatus = FAILED;
    },

    addInsuredRisksToPolicy: (state) => {
      state.addInsuredRisksToPolicyStatus = LOADING;
    },
    addInsuredRisksToPolicySucceeded: (state) => {
      state.addInsuredRisksToPolicyStatus = SUCCEEDED;
    },
    addInsuredRisksToPolicyFailed: (state) => {
      state.addInsuredRisksToPolicyStatus = FAILED;
    },

    updateInsuredRisksToPolicy: (state) => {
      state.updateInsuredRisksToPolicyStatus = LOADING;
    },
    updateInsuredRisksToPolicySucceeded: (state) => {
      state.updateInsuredRisksToPolicyStatus = SUCCEEDED;
    },
    updateInsuredRisksToPolicyFailed: (state) => {
      state.updateInsuredRisksToPolicyStatus = FAILED;
    },

    clearInsuredRisksFromManyPolicies: (state) => {
      state.insuredRisksFromManyPolicies = [];
      state.insuredRisksFromManyPoliciesStatus = IDLE;
    }
  }
});

export const {
  getInsuredRisksForSelectedPolicy,
  getInsuredRisksForSelectedPolicySucceeded,
  getInsuredRisksForSelectedPolicyFailed,
  getInsuredRisksFromManyPolicies,
  getInsuredRisksFromManyPoliciesSucceeded,
  getInsuredRisksFromManyPoliciesFailed,
  addInsuredRisksToPolicy,
  addInsuredRisksToPolicySucceeded,
  addInsuredRisksToPolicyFailed,
  updateInsuredRisksToPolicy,
  updateInsuredRisksToPolicySucceeded,
  updateInsuredRisksToPolicyFailed,
  clearInsuredRisksFromManyPolicies,
  bulkAssignInsuredRisks,
  bulkAssignInsuredRisksSucceeded,
  bulkAssignInsuredRisksFailed,
  bulkUnassignInsuredRisks,
  bulkUnassignInsuredRisksSucceeded,
  bulkUnassignInsuredRisksFailed
} = insuredRisksToPoliciesSlice.actions;

export default insuredRisksToPoliciesSlice.reducer;
